<div class="col-md-12 mt-4">
    <hr/>
    <h5>Información de solicitante</h5>
</div>
<div class="row" [formGroup]="form">
    <div class="col-md-6">
        <label class="form-labels mt-4">Nombre Completo</label>
        <div class="input-group">
            <input type="text" class="form-control" formControlName="name" >
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Email</label>
        <div class="input-group">
            <input type="email" class="form-control" formControlName="email">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Seguro Social</label>
        <div class="input-group">
            <input type="text" class="form-control" formControlName="ss" [brmasker]="{mask: '000-00-0000', type:'num'}" maxlength="11">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Número de Licencia</label>
        <div class="input-group">
            <input type="text" formControlName="licence" class="form-control">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Fecha de Nacimiento</label>
        <input type="date" placeholder="mm-dd-yyyy" formControlName="birthDate" class="form-control">
    </div>

    <div class="col-md-6">
        <label class="form-labels mt-4">Estado Civil</label>
        <select class="form-select" formControlName="civilStatus">
            <option value="casado">Casado</option>
            <option value="soltero">Soltero</option>
        </select>
    </div>

    <div class="col-md-6">
        <label class="form-labels mt-4">Número de Dependientes</label>
        <div class="input-group">
            <input type="number" class="form-control" formControlName="dependientes">
        </div>
    </div>

    <div class="col-md-6">
        <label class="form-labels mt-4">¿Es codeudor o garantizador de esta financiera?</label><br/>
        <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" value="si" formControlName="isCodeudor">
            <label class="form-check-label">Si</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input"  formControlName="isCodeudor"  type="radio" value="no">
            <label class="form-check-label">No</label>
          </div>
    </div>

    <div class="col-md-6">
        <label class="form-labels mt-4">Pago Mensual / Casa</label>
        <div class="input-group">
            <input formControlName="housePayment" type="text" class="form-control">
        </div>
    </div>
    <div class="col-md-6">
        <label class="form-labels mt-4">Años en Residencia</label>
        <div class="input-group">
            <input type="text" formControlName="yearsInHouse" class="form-control">
        </div>
    </div>
</div>

<app-address [address]="solicitante?.address" (formReady)="addChildForm('address', $event)"></app-address>


<app-employer-info [employer]="solicitante?.employer" (formReady)="addChildForm('employer', $event)"></app-employer-info>